export default "__VITE_ASSET__08f63ab0__"